// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesFexcoInauguracion = importAll(
  require.context('../../assets/fexcoInauguracion', true, /\.(png|jpe?g|svg)$/)
);